import React from 'react';
import WeekColumn from './WeekColumn';
import {PhaseAverageColumn} from './AverageColumn';

export default function PhaseColumn({
  reportAnalytics,
  phase,
  displayedQuestions,
  compact,
  openedDay,
  reportType,
  enablePtoAnalytics,
  isApproveReportsLoading,
  popupPosition,
  getWeeks,
  getDays,
  openDay,
  openApproveReports,
  renderReportsState,
  setPopupPosition,
  getSequenceNumber,
  getLogGroup,
  getBackgroundColor,
  getCellColor,
  getCellValue,
  renderCommentPopup,
  getAvgPerDay,
  closeOpenedDay,
  getAvgCellValue,
  getAvgBackgroundColor,
  getTotalTimeSpend,
  getPhaseTotalTimeSpend,
  timeConvert,
}) {
  return (
    <div className="phase" key={phase.guid}>
      <div className="phase-header">{phase.header}</div>
      <div className="weeks">
        {getWeeks(reportAnalytics.weeks[phase.guid], phase, {reportAnalytics}).map(week => (
          <WeekColumn
            key={phase.guid + week.numInPhase}
            reportAnalytics={reportAnalytics}
            phase={phase}
            week={week}
            displayedQuestions={displayedQuestions}
            compact={compact}
            openedDay={openedDay}
            reportType={reportType}
            enablePtoAnalytics={enablePtoAnalytics}
            isApproveReportsLoading={isApproveReportsLoading}
            popupPosition={popupPosition}
            getDays={getDays}
            openDay={openDay}
            openApproveReports={openApproveReports}
            renderReportsState={renderReportsState}
            setPopupPosition={setPopupPosition}
            getSequenceNumber={getSequenceNumber}
            getLogGroup={getLogGroup}
            getBackgroundColor={getBackgroundColor}
            getCellColor={getCellColor}
            getCellValue={getCellValue}
            renderCommentPopup={renderCommentPopup}
            getAvgPerDay={getAvgPerDay}
            closeOpenedDay={closeOpenedDay}
            getAvgCellValue={getAvgCellValue}
            getAvgBackgroundColor={getAvgBackgroundColor}
            getTotalTimeSpend={getTotalTimeSpend}
            timeConvert={timeConvert}
          />
        ))}
        {!enablePtoAnalytics && (
          <PhaseAverageColumn
            reportAnalytics={reportAnalytics}
            phase={phase}
            displayedQuestions={displayedQuestions}
            reportType={reportType}
            openedDay={openedDay}
            getAvgCellValue={getAvgCellValue}
            getAvgBackgroundColor={getAvgBackgroundColor}
            getPhaseTotalTimeSpend={getPhaseTotalTimeSpend}
            timeConvert={timeConvert}
          />
        )}
      </div>
    </div>
  )
}
